<template>
  <div id="cat" v-cloak>
    <div class="vx-row mb-6">
      <div class="vx-col w-full mb-2">
        <vs-button
          @click="createFestival()"
          class="bg_l_green"
          v-has-permission="permission69"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
          {{ $t("CreateNewFestival") }}
        </vs-button>
      </div>
    </div>
    <modify-popup
      :show="ModifyPopup"
      :model="modalModel"
      @close="closeModifyPopup"
      @finish="onfinish"
    ></modify-popup>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          :columns="[
            { title: $t('FestivalName'), sort: 'FestivalName' },
            { title: $t('StartDate'), sort: 'StartClock' },
            { title: $t('EndDate'), sort: 'ExpireClock' },
            { title: $t('DiscountsCount'), sort: 'DiscountsCount' },
            { title: $t('CreateOn'), sort: 'CreateOn' },
            { title: $t('Action') },
          ]"
        >
          <template slot-scope="{ row }">
            <td style="width: 22%">
              {{ row.name }}
            </td>
            <td style="width: 15%; direction: ltr">
              {{ row.startClock }}
            </td>
            <td style="width: 15%; direction: ltr">
              {{ row.expireClock }}
            </td>
            <td style="width: 7%">
              {{ row.discountsCount }}
            </td>
            <td style="width: 15%; direction: ltr">
              {{ row.createOn.split(" ")[0] }}<br />{{
                row.createOn.split(" ")[1]
              }}
            </td>
            <td style="width: 25%">
              <vs-button
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-eye"
                class="custom-border-btn"
                @click="viewProducts(row.id)"
                v-has-permission="permission70"
                >{{ $t("ViewProducts") }}</vs-button
              >
              <vs-button
                radius
                color="success"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-edit"
                @click.prevent="editFestival(row)"
                v-has-permission="permission71"
                class="ml-2 d-inline"
              ></vs-button>
              <vs-button
                radius
                color="danger"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-x"
                @click.prevent="deleteFestival(row.id)"
                class="d-inline"
                v-has-permission="permission72"
              ></vs-button>
            </td>
          </template>
        </data-grid>
      </div>
    </div>
    <product-popup
      :show="ProductPopup"
      :model="productModel"
      @close="closeProductPopup"
    ></product-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import Treeselect from "@/components/CustomTreeSelect.vue";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import ModifyPopup from "./ModifyPopup.vue";
import ProductPopup from "./ProductPopup.vue";
export default {
  components: {
    DataGrid,
    Treeselect,
    "v-select": vSelect,
    ModifyPopup,
    ProductPopup,
  },
  data() {
    return {
      permission72: "DeletePromotionCategory",
      permission71: "ModifyPromotionCategory",
      permission70: "GetAllProductDiscountByCategory",
      permission69: "CreatePromotionCategory",
      ModifyPopup: false,
      modalModel: {},
      ProductPopup: false,
      productModel: {},
      contractId: this.$route.params.id,
      gridDataSource: {
        type: "app",
        service: "Promotion/api/Categories",
      },
      gridSearchData: {
        contractId: this.$route.params.id,
      },
    };
  },
  methods: {
    ...mapActions({
      removeFestival: "festival/remove",
    }),
    createFestival() {
      this.modalModel = {};
      this.ModifyPopup = true;
    },
    viewProducts(id) {
      this.productModel = { categoryId: id };
      this.ProductPopup = true;
    },
    editFestival(model) {
      this.modalModel = {
        id: model.id,
        name: model.name,
        startClock: model.startClock,
        expireClock: model.expireClock,
        contractId: model.contractId,
      };
      this.ModifyPopup = true;
    },
    deleteFestival(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeFestival(id).then(() => {
            setTimeout(() => {
              this.$refs.grid.renderGrid();
            }, 2000);
          });
        }
      });
    },
    closeProductPopup() {
      this.ProductPopup = false;
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
